export enum RugbyLeagueKickAttribute {
  Pass = 2996,
  KickForTouch = 2997,
  Clearance = 2998,
  RestartKick = 2999,
  UpAndUnder = 3000,
  TapKick = 3001,
  CollectedByOffense = 3002,
  FortyTwentyKick = 3003,
}
